import { Root } from "@radix-ui/react-collapsible";
import { cx } from "@suse-o11y/class-variance";
import React from "react";

export type BoundaryProps = React.ComponentPropsWithoutRef<typeof Root>;

export const Boundary = React.forwardRef<React.ComponentRef<typeof Root>, BoundaryProps>(
	({ className, ...props }, ref) => (
		<Root {...props} className={cx("suse-o11y/collapsible-boundary", className)} ref={ref} />
	),
);

Boundary.displayName = "Collapsible.Boundary";
